import { render, staticRenderFns } from "./picker-category.vue?vue&type=template&id=459a2f65"
import script from "./picker-category.vue?vue&type=script&lang=js"
export * from "./picker-category.vue?vue&type=script&lang=js"
import style0 from "./picker-category.vue?vue&type=style&index=0&id=459a2f65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports